import React, { useState } from 'react';
import { Button, Drawer, Flex, Image } from 'antd';
import { NavLinksItems } from '../Hooks/NavLinks';
import logo from '../assets/images/logo.png';
import { BiMenuAltLeft } from 'react-icons/bi';
import { useSelector } from 'react-redux';
import { IoClose } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

const Header = ({ t }) => {
  const { currentLang } = useSelector((state) => state.user);
  const [open, setOpen] = useState(false);
  const navigator = useNavigate();
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  return (
    <div
      className="header"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        height: '100%',
        position: 'relative',
      }}
    >
      <Flex align="center" justify="space-between" style={{ width: '100%' }}>
        <div
          className="logo"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Button type="text" onClick={showDrawer} className="btn-menu">
            <BiMenuAltLeft size={40} />
          </Button>
          <div
            onClick={() => navigator(currentLang === 'ar' ? '/ar' : '/')}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
          >
            <Image
              src={logo}
              alt="logo"
              preview={false}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                // width: '150px',
                height: '80px',
                cursor: 'pointer',
              }}
            />
          </div>
        </div>
        <Flex align="center" justify="center" gap={70} className="nav-links">
          <NavLinksItems t={t} />
        </Flex>
      </Flex>
      <Drawer
        onClose={onClose}
        open={open}
        placement={currentLang === 'ar' ? 'right' : 'left'}
        style={{
          background: '#242424',
        }}
        closeIcon={false}
        className="drawer-header"
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            marginBottom: 20,
            cursor: 'pointer',
          }}
          onClick={() => {
            navigator(currentLang === 'ar' ? '/ar' : '/');
            onClose();
          }}
        >
          <Image
            src={logo}
            alt="logo"
            preview={false}
            width={100}
            height={70}
          />
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'start',
            justifyContent: 'start',
            flexDirection: 'column',
            width: '100%',
            gap: 50,
          }}
          className="nav-links-drawer"
        >
          <NavLinksItems t={t} onClose={onClose} />
        </div>
        <Button
          onClick={onClose}
          className="btn-close"
          type="text"
          style={{
            position: 'absolute',
            top: 50,
            right: currentLang === 'ar' ? 'auto' : '-50px',
            left: currentLang === 'ar' ? '-50px' : 'auto',
            transform: 'translateX(50%)',
            cursor: 'pointer',
            width: 'fit-content',
          }}
          icon={<IoClose size={30} />}
        />
      </Drawer>
    </div>
  );
};

export default Header;
